"use strict";exports.asType=function(t){return t};
//# sourceMappingURL=asType.cjs.map
